module.exports = __webpack_public_path__ + "static/media/plus-circle-coinera.7a4e1141.svg";